$(function () {
    // Sticky header
    var observer = new IntersectionObserver(
        function (entries) {
            // no intersection with screen
            if (0 === entries[0].intersectionRatio) {
                document.querySelector('#header-bar').classList.add('sticky')
            }

            // fully intersects with screen
            else if (1 === entries[0].intersectionRatio) {
                document.querySelector('#header-bar').classList.remove('sticky')
            }
        },
        {
            threshold: [0, 1],
        }
    )

    observer.observe(document.querySelector('#sticky-menu-top'))

    // Masks
    var maskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11
                ? '(00) 00000-0000'
                : '(00) 0000-00009'
        },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options)
            },
        }
    $('.form-tel').mask(maskBehavior, options)
    $('.form-cep').mask('00000-000')

    // Get container offset
    offsetWidth()
    $(window).on('resize', function () {
        offsetWidth()
    })

    function offsetWidth() {
        var containerOffset = $('.container').offset().left
        $('.container-offset').css('width', containerOffset)
        $('.container-right').css('right', containerOffset)

        var imageWidth = 'calc(66.6% - ' + containerOffset + 'px)'
        $('.slider-thumb').css('width', imageWidth)
    }

    // Fancybox
    Fancybox.bind()
})
